// extracted by mini-css-extract-plugin
export default {"CostMetricsAggregatedDetailsTable":"qmqXygpVKKxJmWqgd_lb","CostMetricsDetailsFootPrintContainerTable":"Tl4FaWxOFDIVF3e_Ni6u"};